import { Collapse } from "antd";
import useIsMobile from "../../../hooks/useIsMobile";
import "./summary-wrapper.css";
import "../summary.css";

/**
 * SummaryWrapper - Replaces raw Descriptions with collapsible, styled sections.
 *
 * @param {Array} items - Array of { key, label, children } (same shape as Descriptions items)
 * @param {ReactNode} [title] - Optional title with icon (used by IP EMR child summaries)
 * @param {boolean} [collapseAllOnMobile] 
 */
const SummaryWrapper = ({ items = [], title, collapseAllOnMobile = false }) => {
  const isMobile = useIsMobile();

  if (!items || items.length === 0) return null;

  const collapseItems = items.map((item) => ({
    key: item.key,
    label: item.label,
    children: <div className="summary-content">{item.children}</div>,
  }));

  const defaultActiveKeys =
    isMobile || collapseAllOnMobile ? [] : items.map((item) => item.key);

  return (
    <div className="summary-wrapper">
      {title && <div className="summary-wrapper-title">{title}</div>}
      <Collapse
        defaultActiveKey={defaultActiveKeys}
        ghost={false}
        className="summary-collapse"
        items={collapseItems}
      />
    </div>
  );
};

export default SummaryWrapper;
